var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { Form } from '@/components/functional/Form/Form';
import { MultiTextField } from '@/components/functional/Form/MultiTextField';
import { SubmitButton } from '@/components/functional/Form/SubmitButton';
import { Button } from '@/components/ui/Button/Button';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { PhoneField } from '@/components/ui/Form/PhoneField';
import { hotlineText } from '@/feature/hotline/constant/text';
import { hotlineProScheduleRequestFormStyle, } from '@/feature/hotline/professional/detail/component/HotlineProScheduleRequestForm/style';
import { hotlineProfessionalDetailText } from '@/feature/hotline/professional/detail/constant/text';
import { hotlineProScheduleRequestFormSchema, hotlineProScheduleRequestUpdateFormSchema, } from '@/feature/hotline/professional/detail/util/hotlineProScheduleRequestFormSchema';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useBoolState } from '@/hooks/state/useBoolState';
import { FIELD_DOM_CLASS_NAME } from '@/utils/form/scroll';
import { zodFinalFormValidate } from '@/utils/libs/zod/validate';
const { label } = hotlineProfessionalDetailText;
/**
 * 匿名ホットライン 日程承諾・連絡先更新フォーム
 */
export const HotlineProScheduleRequestForm = (props) => {
    const { className = '', defaultValues, disabled = false, fixedTextBgColor, isUpdate, onSubmit: propOnSubmit, showLabel = true, } = props;
    // form の表示状態
    const { boolState: isShowForm, changeFalse: hideForm, changeTrue: showForm, } = useBoolState();
    const unmountRef = useUnmountRef();
    const style = hotlineProScheduleRequestFormStyle({ fixedTextBgColor });
    const onSubmit = useCallback((formValue) => __awaiter(void 0, void 0, void 0, function* () {
        yield propOnSubmit(formValue);
        // 電話番号更新後はフォームを非表示にする
        if (!unmountRef.current && isUpdate) {
            hideForm();
        }
    }), [propOnSubmit, unmountRef, hideForm, isUpdate]);
    // 確定日程表示
    if (isUpdate && !isShowForm) {
        return (_jsxs("div", Object.assign({ className: style.base({ class: className }) }, { children: [_jsxs("div", Object.assign({ className: style.phone() }, { children: [showLabel && _jsx(FieldLabel, { labelText: label.phone() }), _jsx("div", Object.assign({ className: style.fixedText() }, { children: `${defaultValues.phone1}-${defaultValues.phone2}-${defaultValues.phone3}` }))] })), _jsx(Button, Object.assign({ className: style.button(), color: 'navy', onClick: showForm, size: 'md' }, { children: "\u96FB\u8A71\u756A\u53F7\u3092\u4FEE\u6B63\u3059\u308B" }))] })));
    }
    // 入力表示
    return (_jsx(Form, { initialValues: isUpdate
            ? defaultValues
            : Object.assign(Object.assign({}, defaultValues), { timeSchedule: '例：〇〇を検討する際の全体ステップの説明（10分）' }), onSubmit: onSubmit, render: ({ handleSubmit, submitting }) => (_jsxs("form", Object.assign({ className: style.base({ class: className }), onSubmit: handleSubmit }, { children: [_jsx(PhoneField, { classNames: {
                        inputWrap: style.phoneInputWrap(),
                        label: FIELD_DOM_CLASS_NAME,
                    }, fieldNames: {
                        phone1: 'phone1',
                        phone2: 'phone2',
                        phone3: 'phone3',
                    }, label: label.phone() }), !isUpdate && (_jsx(FieldLabel, Object.assign({ className: FIELD_DOM_CLASS_NAME, isRequired: true, labelText: label.timeSchedule() }, { children: _jsx(MultiTextField, { minRows: 4, name: 'timeSchedule' }) }))), _jsx(SubmitButton, Object.assign({ className: style.button(), color: 'orange', disabled: submitting || disabled, loading: submitting, size: 'md' }, { children: isUpdate ? '電話番号を更新する' : hotlineText.action.accept() }))] }))), validate: zodFinalFormValidate(isUpdate
            ? hotlineProScheduleRequestUpdateFormSchema
            : hotlineProScheduleRequestFormSchema) }));
};
